import { IssueTaskDoc, IssueTaskStatus } from '@gooduncles/gu-app-schema';
import { useEffect, useState } from 'react';

import { observeIssueTasks } from 'src/utils/firebase/firebase-short-cut';

interface UseIssueTasksForCasesResult {
  tasksByCase: { [caseId: string]: IssueTaskDoc[] };
  allTasks: IssueTaskDoc[];
  totalCount: number;
  isLoading: boolean;
}

const useIssueTasksForCases = (caseIdString: string | undefined): UseIssueTasksForCasesResult => {
  const [issueTasks, setIssueTasks] = useState<IssueTaskDoc[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (caseIdString && caseIdString.length > 0) {
      const caseIds = caseIdString.split(',').filter(Boolean);
      setIsLoading(true);
      const subscription = observeIssueTasks([
        ['issueCaseId', 'in', caseIds],
        [
          'status',
          'in',
          [
            IssueTaskStatus.PENDING,
            IssueTaskStatus.OPEN,
            IssueTaskStatus.IN_PROGRESS,
            IssueTaskStatus.FAILED,
            IssueTaskStatus.COMPLETED,
            IssueTaskStatus.CANCELED,
          ],
        ],
      ]).subscribe((docs) => {
        setIssueTasks(docs);
        setIsLoading(false);
      });
      return () => subscription.unsubscribe();
    } else {
      setIssueTasks([]);
      setIsLoading(false);
    }
  }, [caseIdString]);

  const tasksByCase = issueTasks.reduce(
    (acc, task) => {
      const caseId = task.issueCaseId;
      if (!acc[caseId]) {
        acc[caseId] = [];
      }
      acc[caseId].push(task);
      return acc;
    },
    {} as { [caseId: string]: IssueTaskDoc[] },
  );

  return {
    tasksByCase,
    allTasks: issueTasks,
    totalCount: issueTasks.length,
    isLoading,
  };
};

export default useIssueTasksForCases;
